import React from 'react';
import { Plus, Minus } from 'lucide-react';

interface BetLevelsEditorProps {
  betLevels: number[];
  onChange: (betLevels: number[]) => void;
}

export const BetLevelsEditor: React.FC<BetLevelsEditorProps> = ({
  betLevels,
  onChange,
}) => {
  const updateLevel = (index: number, value: number) => {
    const updated = betLevels.map((v, i) => (i === index ? value : v));
    onChange(updated);
  };

  const addLevel = () => {
    const last = betLevels[betLevels.length - 1] ?? 100;
    onChange([...betLevels, last * 2]);
  };

  const removeLevel = (index: number) => {
    if (betLevels.length <= 1) return;
    onChange(betLevels.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-1">
      {betLevels.map((level, index) => (
        <div key={index} className="flex items-center gap-1 px-1">
          <input
            className="bg-zinc-800 border border-zinc-700 rounded px-1.5 py-0.5 text-xs text-zinc-300 flex-1 text-center"
            type="number"
            value={level}
            min={1}
            onChange={(e) => updateLevel(index, parseInt(e.target.value) || 1)}
          />
          <button
            className="p-0.5 rounded hover:bg-zinc-700 text-zinc-500 hover:text-zinc-300"
            onClick={() => removeLevel(index)}
            title="Remove"
            disabled={betLevels.length <= 1}
          >
            <Minus size={12} />
          </button>
        </div>
      ))}
      <button
        className="flex items-center gap-1 px-1 py-0.5 text-xs text-zinc-400 hover:text-zinc-200"
        onClick={addLevel}
      >
        <Plus size={12} />
        Add Bet Level
      </button>
    </div>
  );
};
